export default __webpack_public_path__ + "static/media/max.76600596.svg";